<template>
  <div class="shop-email">
    <!-- 发送邮件 -->
    <dl class="email">
      <dt class="email-header">发 Email 给商家</dt>
      <dd class="email-form__list">
        <div class="email-form__item">
          <el-input
            v-model="form.content"
            clearable
            placeholder="请输入想咨询的内容了解更多…"
            type="textarea"
            :autosize="{ minRows: 3 }"
            resize="none"
          ></el-input>
        </div>
        <div class="email-form__item">
          <el-input placeholder="姓名" v-model="form.name" clearable></el-input>
        </div>
        <div class="email-form__item">
          <el-input placeholder="Email" v-model="form.email" clearable></el-input>
        </div>
        <div class="email-form__item">
          <el-button :loading="submitLoading" @click="sendEmail">立即咨询</el-button>
        </div>
      </dd>
      <dd class="email-more" v-if="![1, 2].includes(post.property.payType)">
        <el-checkbox v-model="form.more" :true-label="1" :false-label="0">一键咨询更多的行业商家</el-checkbox>
        <button class="email-button__show" @click="visible = true">查看详情</button>
      </dd>
    </dl>

    <!-- 对话框 -->
    <el-dialog class="shop-dialog" width="700px" title="一键咨询" :visible.sync="visible">
      <el-checkbox-group class="shop-list" v-model="form.morePostId" @change="onCheckChange">
        <el-checkbox class="shop-item" v-for="item in posts" :key="item.id" :label="item.id">
          <YorkbbsImage
            width="60px"
            height="45px"
            borderRadius="4px"
            :src="item.property.coverImage | webpFormat(100)"
          ></YorkbbsImage>
          <div class="shop-desc">
            <div class="shop-title__wrapper e">
              <span>{{ item.property.shopCnName }}</span>
              <span v-if="item.property.shopCnName != item.title">{{ item.title }}</span>
            </div>
            <div class="shop-topic">
              {{ item.property.topics[0].name }}
            </div>
          </div>
        </el-checkbox>
      </el-checkbox-group>
      <div class="shop-footer" slot="footer">
        <el-checkbox :indeterminate="indeterminate" v-model="checkAll" @change="onCheckAll">全选</el-checkbox>
        <el-button class="shop-button__send" @click="onSendButtonClicked">发送</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { regexEmail } from '@/common/account/utils/regex';
export default {
  name: 'ShopEmail',
  props: { post: Object },
  data() {
    return {
      form: {
        content: '', // 邮件内容
        name: '', // 姓名
        email: '', // 邮箱
        more: 1, // 是否咨询更多的商家
        morePostId: [], // 更多商家信息ID
      },

      submitLoading: false, // 发送邮件状态

      visible: false, // 对话框显示状态
      loading: false, // 数据加载状态
      posts: [], // 信息列表
      indeterminate: false,
      checkAll: true,

      isSended: false, // 是否已发送过邮件
    };
  },
  created() {
    this.getPosts();
  },
  methods: {
    /**
     * 获取信息列表
     */
    async getPosts() {
      this.loading = true;
      const { data } = await this.$axios
        .post('/info/v1/get/post/list', {
          offset: 1,
          size: 6,
          topicEngName: this.$route.params.topic,
          notId: [this.$route.params.id],
        })
        .finally(() => {
          this.loading = false;
        });

      this.isSended = false;
      this.posts = data.items;
      this.form.morePostId = data.items.map(item => item.id);
    },
    /**
     * 全选
     */
    onCheckAll(val) {
      this.form.morePostId = val ? this.posts.map(item => item.id) : [];
      this.indeterminate = false;
    },
    /**
     * 选项发生变化
     */
    onCheckChange(val) {
      const checkedCount = val.length;
      this.checkAll = checkedCount === this.posts.length;
      this.indeterminate = checkedCount > 0 && checkedCount < this.posts.length;
    },
    /**
     * 点击对话框发送按钮
     */
    onSendButtonClicked() {
      this.visible = false;
      this.sendEmail();
    },
    /**
     * 发送邮件
     */
    async sendEmail() {
      if (this.isSended) return this.$warning('您已经发送过邮件了');

      if (!this.form.content) return this.$warning('请输入咨询内容');
      if (!this.form.name) return this.$warning('请输入您的姓名');
      if (!regexEmail.test(this.form.email)) return this.$warning('请输入有效的邮箱');

      this.submitLoading = true;
      await this.$axios
        .post('/info/v1/consult/merchant', {
          ...this.form,
          postId: this.$route.params.id,
        })
        .finally(() => {
          this.submitLoading = false;
        });

      this.$success('已经向商家发出咨询');

      this.form.content = '';
      this.form.name = '';
      this.form.email = '';

      this.isSended = true;
    },
  },
};
</script>
<style lang="scss" scoped>
.email {
  padding: 20px;
  background: #ffffff;
  border: 1px solid #ededed;
  border-radius: 4px;
  margin-bottom: 20px;
}
.email-header {
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  margin-bottom: 15px;
}

.email-form__item {
  &:not(:first-child) {
    margin-top: 10px;
  }
  &:last-child {
    margin-top: 20px;
  }
}

.email-more {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 15px;
}

.email-button__show {
  font-size: 12px;
  color: #156db6;
  text-decoration: underline;
}

.email {
  ::v-deep {
    .el-textarea__inner,
    .el-input__inner {
      border: 0 none;
      background: #f8f8f8;
    }
    .el-checkbox__label {
      font-size: 14px;
    }
  }
  .el-button {
    width: 100%;
  }
}

.shop-dialog {
  ::v-deep {
    .el-dialog__body {
      min-height: 400px;
      max-height: 800px;
      overflow-y: auto;
    }
  }
}

.shop-list {
  display: flex;
  flex-wrap: wrap;
}

.shop-item {
  display: flex;
  align-items: center;
  width: 50%;
  margin-right: 0;
  box-sizing: border-box;
  overflow: hidden;
  margin-bottom: 30px;
}

.shop-desc {
  width: 180px;
  margin-left: 10px;
}

.shop-title__wrapper {
  font-size: 16px;
  color: var(--text-color-3);
  margin-bottom: 10px;
}

.shop-topic {
  font-size: 14px;
  color: var(--text-color-9);
}

.shop-footer {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.shop-button__send {
  width: 100px;
  height: 40px;
  background: var(--primary-color);
  border-radius: 4px;
  font-size: 16px;
  color: #fff;
  border: 0 none;
  padding: 0;
  line-height: 40px;
}

.shop-dialog {
  ::v-deep {
    .el-dialog__header {
      padding: 30px 30px 0 30px;
    }
    .el-dialog__title {
      font-size: 16px;
      font-weight: bolder;
    }
    .el-dialog__body {
      padding: 30px;
    }
  }
}

.shop-item {
  ::v-deep {
    .el-checkbox__label {
      flex: 1;
      display: flex;
      align-items: center;
      white-space: normal;
    }
  }
}
</style>
